import { AdminDashboardDataFilter, AdminDashboardModelsStatsResponse } from '../../graphql/API';
import { adminGetDashboardModelsStatsData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardModelsStatsDataApi = async (
  filter: AdminDashboardDataFilter,
): Promise<AdminDashboardModelsStatsResponse> => {
  const result = await executeGql(adminGetDashboardModelsStatsData, { filter });
  return processGqlResult<AdminDashboardModelsStatsResponse>(
    'adminGetDashboardModelsStatsData',
    result,
  );
};
